import { Button } from "@mantine/core";
import { type JSX, useEffect, useState } from "react";

import type { GuideActionOption } from "../logic-builder";

interface GuideActionButtonProps {
    className: string;
    currentStep: string;
    disabled?: boolean;
    isLoadingStep: boolean;
    onClick: (option: GuideActionOption) => void;
    option: GuideActionOption;
}

export function GuideActionButton({
    className,
    currentStep,
    disabled = false,
    isLoadingStep,
    onClick,
    option,
}: GuideActionButtonProps): JSX.Element {
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const handleButtonClick = () => {
        setIsLoadingButton(true);
        onClick(option);
    };

    useEffect(() => {
        setIsLoadingButton(false);
    }, [currentStep]);

    return (
        <Button
            className={className}
            loading={isLoadingStep && isLoadingButton}
            disabled={isLoadingStep || disabled}
            miw="5.5rem"
            onClick={handleButtonClick}
            size="xs"
            fz="xs"
            variant={option.variant ?? "default"}
        >
            {option.label}
        </Button>
    );
}
